import * as classnames from 'classnames'
import * as React from 'react'

import { IItemCard } from '../interface'

import LockupAddToCartButton from '../lockupAddToCartButton'
import LockupPrice from '../lockupPrice'
import LockupRating from '../lockupRating'
import LockupSales from '../lockupSales'

import * as styles from './itemCardSmallSidebar.module.css'

const ItemCardSidebar = (props: IItemCard) => {
  return (
    <section className={styles.root}>
      <section className={styles.itemMeta}>
        <span>
          <span
            className={classnames(styles.price, {
              [styles.gridPrice]: props.viewType === 'grid'
            })}
          >
            <LockupPrice priceInCents={props.item.price_cents} />
          </span>
          <span
            className={classnames({
              [styles.ratingAndSalesGrid]: props.viewType === 'grid'
            })}
          >
            <LockupRating {...props} />
            <LockupSales {...props} />
          </span>
        </span>
        <span className={styles.cartButton}>
          <LockupAddToCartButton icon {...props} />
        </span>
      </section>
    </section>
  )
}

export default ItemCardSidebar
